import { type TFunction } from "i18next";

import { PaymentType } from "@/api-v3";

export const getPaymentTitle = (type: PaymentType, t: TFunction): string => {
  switch (type) {
    case PaymentType.stipend:
      return t("stipend");
    case PaymentType.micropayment:
      return t("micropayment");
    case PaymentType.receipt_claim:
      return t("receiptClaim");
    case PaymentType.mileage_claim:
      return t("mileageClaim");
  }
};
